export default __webpack_public_path__ + "static/3p8-ultrasound-a75d37e05ce7fc827fbb3ea02a930564.png";